import { stringSearch } from '@luminovo/design-system';
import { createFileRoute } from '@tanstack/react-router';
import type { JSX } from 'react';

import { NegotiationCostBreakdownAssemblyDetailPage } from '@/areas/cost-breakdown/CostBreakdown/NegotiationCostBreakdown/NegotiationCostBreakdownAssemblyDetailPage';
import { isInternalUser } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute(
    '/_authenticated/negotiations/$negotiationId/_sidebar/scenarios/$sourcingScenarioId/cost-breakdown/assembly/$assemblyId/demand/$demandId',
)({
    staticData: { access: { permissions: isInternalUser }, chrome: 'home' } satisfies PageStaticData,
    validateSearch: stringSearch({ parentPath: 'optional' }),
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    const pathParams = Route.useParams();
    const parentPath = Route.useSearch({ select: (search) => search.parentPath });
    return <NegotiationCostBreakdownAssemblyDetailPage {...pathParams} parentPath={parentPath} />;
}
